import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const VestfrostPreset = definePreset(Aura, {
  semantic: {
    // ── Primary color palette based on --vf-brand (#003EA6) ─────────
    primary: {
      50:  '#EEF4FF',
      100: '#DBEAFE',
      200: '#BFDBFE',
      300: '#93C5FD',
      400: '#60A5FA',
      500: '#003EA6',
      600: '#002d7d',
      700: '#002060',
      800: '#001440',
      900: '#000c28',
      950: '#000614'
    },

    // ── Surface / neutral scale mapped to --vf-* slate palette ───────
    colorScheme: {
      light: {
        primary: {
          color:        '#003EA6',
          inverseColor: '#ffffff',
          hoverColor:   '#002d7d',
          activeColor:  '#002d7d'
        },
        surface: {
          0:   '#ffffff',
          50:  '#F4F6F9',
          100: '#F1F5F9',
          200: '#E2E8F0',
          300: '#CBD5E1',
          400: '#94A3B8',
          500: '#64748B',
          600: '#475569',
          700: '#334155',
          800: '#1E293B',
          900: '#0F172A',
          950: '#020617'
        }
      }
    }
  },

});
